const isLocalStorageSupported = "localStorage" in window && window["localStorage"] !== null;

/**
 * Is key in storage
 *
 * @param key {String}
 * @return {boolean}
 */
const isKeyInStorage = key => null !== localStorage.getItem(key);

/**
 * Get key from storage
 *
 * @param key {String}
 * @return {String|null}
 */
const getKeyFromStorage = key => localStorage.getItem(key);

/**
 * Delete key from storage
 *
 * @param key {String}
 */
const deleteKeyFromStorage = key => localStorage.removeItem(key);

/**
 * Set key in storage
 *
 * @param key {String}
 * @param value {String}
 */
const setKeyInStorage = (key, value) => localStorage.setItem(key, value);

export {isKeyInStorage, getKeyFromStorage, setKeyInStorage, deleteKeyFromStorage};
